import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to monitor page performance and navigation through Sentry
 * Use this in your top-level components to track route changes
 */
const useSentryMonitoring = () => {
  const location = useLocation();

  useEffect(() => {
    // Add breadcrumb for navigation events
    Sentry.addBreadcrumb({
      category: 'navigation',
      message: `Navigated to ${location.pathname}`,
      level: 'info',
    });

    // Note: We don't need to manually create transactions anymore
    // The reactRouterV6BrowserTracingIntegration handles this automatically
  }, [location.pathname]);
};

export default useSentryMonitoring; 